import React from 'react';
import {Column, DescriptiveText, LoadingSpinner} from '../../../shared';
import debug from 'debug';
import PropTypes from 'prop-types';
import PrefGroup from './PrefGroup';
import Row from '../Row';
import SectionTitle from '../SectionTitle';
import Image from '../Image';

const log = debug('circleblack:preferences:collection');

function PrefCollection({collection, updateCore, panel, preferenceButtons, preferenceCheckboxes, skipTitle}) {
  log('rendering');
  // TODO reqs Image component, taking into account wealthalert preference collections for Risk images
  // $scope.logoColors = {'riskalyze:advisor': '#476478', 'totum:advisor': '#353C50'};

  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    if (loading && collection) {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return <LoadingSpinner/>;
  }

  return <Column margin={'5px 0 5px 0'}>
    {!skipTitle && <SectionTitle title={collection.displayName}/>}
    {collection.description && <DescriptiveText alignment={'left'}>
      <span dangerouslySetInnerHTML={{__html: collection.description}}/>
    </DescriptiveText>}
    {/*TODO Reqs maxHeight and maxWidth*/}
    {collection.image && <Image maxHeight={'100px'} maxWidth={'220px'} src={collection.image}/>}
    <Row wrap={true} justifySubRow={'left'} alignSubRow={'top'} alignItems={'top'}>
      {collection.groups.map(group => <PrefGroup key={`group-${group.title}`}
                                                 group={group}
                                                 updateCore={updateCore}
                                                 preferenceButtons={preferenceButtons}
                                                 preferenceCheckboxes={preferenceCheckboxes}
                                                 panel={panel}/>)}
    </Row>
  </Column>;
}

export default PrefCollection;

PrefCollection.propTypes = {
  collection: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.string,
    groups: PropTypes.array.isRequired,
  }).isRequired,
  /**
   * Pass-through to PrefCore
   */
  updateCore: PropTypes.func.isRequired,
  /**
   * If true the Collection's Title is not displayed
   */
  skipTitle: PropTypes.bool,
  /**
   * Pass-through to PrefCore
   */
  panel: PropTypes.object,
  /**
   * Pass-through to PrefCore
   */
  preferenceButtons: PropTypes.object,
  /**
   * Pass-through to PrefCore
   */
  preferenceCheckboxes: PropTypes.object,
};
